import React, { Component } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { TableButton } from '../TableButton';
import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../LoadingSpinner';
import { BusMapAPI } from '../../api/busmap/BusMapAPI';
import { TitleRow } from '../../components/TitleRow';
import { DownloadCommand } from '../files/commands/DownloadCommand';
import { HandleMessage } from '../../components/HandleMessage';
import { PaginationBuilder } from '../PaginationBuilder';
import { DownloadLinkHelper } from '../helpers/DownloadLinkHelper';
import { PaginationHelper } from '../helpers/PaginationHelper';
import { strings } from './strings';

export class ListBusMaps extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
    }

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            showDialog: false,
            showDeleteDialog: false,
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('busmap', false);

        this.getBusMaps();
    }

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    setErrorMessage() {
        this.setState({
            loading: false,
            showDialog: true,
            message: {
                show: true,
                title: strings.error,
                message: strings.errorLoadingDocs,
                style: 'danger',
                icon: 'remove'
            }
        });
    }

    processBusMapList(data) {
        var { table } = this.state;

        const totalPages = PaginationHelper.getTotalPages(data.length, table.elementsPerPage);

        table.data = data;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            loading: false,
            table: table
        });
    }

    getBusMaps() {
        if (this.isTransportAuthorityData()) {
            BusMapAPI.listTransportAuthority()
                .then(response => JSON.parse(response))
                .then(data => this.processBusMapList(data))
                .catch(_ => this.setErrorMessage());
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            BusMapAPI.list(selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processBusMapList(data))
                .catch(_ => this.setErrorMessage());
        }
    }

    errorCallback(message) {
        const { table } = this.state;

        table.page = 1;
        table.data = [];

        this.setState({
            table: table,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        }, () => this.getBusMaps());
    }

    startDownload(format, name) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const downloadCommand = new DownloadCommand();
        downloadCommand.downloadBusmap(
            this.isTransportAuthorityData(),
            format, 
            selectedProviderId,
            (a) => this.saveAs(a, name),
            (a) => this.errorCallback(a)
        );
    }

    saveAs(blob, format) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, format);
    }

    // Pagination functions 

    onChangePage = (pageNumber) => {
        const { table } = this.state;
        table.page = parseInt(pageNumber, 10)

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage = (elementsPerPage) => {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, parseInt(elementsPerPage, 10));

        table.elementsPerPage = parseInt(elementsPerPage, 10);
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    // Render functions

    renderDownloadLink(link, downloadName, extention) {
        if (undefined === link || null === link || "" === link) {
            return null;
        }

        const schedName = link.split('/');
        const fileName = schedName[schedName.length - 1];

        return (
            <TableButton
                icon="icon-download"
                onClick={() => this.startDownload(fileName, DownloadLinkHelper.getDownloadFileName(fileName, downloadName, extention))}
                title="Transferir"
            />
        );
    }

    getBusMapList() {
        var { table, message } = this.state;

        const partialData = table.data.slice((table.page - 1) * table.elementsPerPage, table.page * table.elementsPerPage);

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        {typeof table.data !== "undefined" && table.data.length !== 0 ?
                            <div>
                                <Table className="">
                                    <thead>
                                        <tr>
                                            <th>{strings.code}</th>
                                            <th>{strings.description}</th>
                                            <th>{strings.generationDate}</th>
                                            <th>{strings.part}</th>
                                            <th>SVG</th>
                                            <th>PNG</th>
                                            <th>PDF</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            partialData.map((busMap, busMapIndex) =>
                                                <tr key={busMapIndex}>
                                                    <td>{busMap.stopCode}</td>
                                                    <td>{busMap.stopName}</td>
                                                    <td>{busMap.generationDate}</td>
                                                    <td>{busMap.part}</td>
                                                    <td>{this.renderDownloadLink(busMap.fileUrlSvg, busMap.downloadName, "svg")}</td>
                                                    <td>{this.renderDownloadLink(busMap.fileUrlPng, busMap.downloadName, "png")}</td>
                                                    <td>{this.renderDownloadLink(busMap.fileUrlPdf, busMap.downloadName, "pdf")}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </Table>

                                <PaginationBuilder
                                    currentPage={table.page}
                                    elementsPerPage={table.elementsPerPage}
                                    dataLength={table.data.length}
                                    onChangePage={(a) => this.onChangePage(a)}
                                    onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                            </div>
                            : <p className="empty-set">{strings.noExistingBusMaps}</p>}
                    </Col>
                </Row>

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

            </div>
        );
    }

    render() {
        var { loading } = this.state;

        if (loading) {
            return <LoadingSpinner />;
        }

        return <div className="container-fluid busmap">
            <TitleRow title={strings.existingBusMaps} showSeparator={true} />
            {this.getBusMapList()}
        </div>
    }
}
